import React from "react";
import styles from "./index.module.scss";
import { toUpperCaseWords } from "@/utils/formatTools";

const TitleCard = (props) => {
  const { title = "", className = "" } = props;

  if (!title) {
    return null;
  }

  return (
    <div className={`mt4 ${styles.title_card} ${className}`}>
      <h1 className={`${styles.title}`}>{toUpperCaseWords(title)}</h1>
    </div>
  );
};

export default TitleCard;
